import React from 'react'
import Topheader from '../../components/Topheader'
import style from './styles.module.css'
export default function ESGeneralQueries() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Consultas Generales" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  ¿Qué es la versión de Juego Gratuito de PokerBaazi?
                </div>
                <div className={style.sub_text3}>
                    La versión de Juego Gratuito te permite disfrutar de toda la emoción del póker sin usar dinero real. Juegas con fichas gratuitas, ganas Puntos de Recompensa jugando y los canjeas en la Baazi Store por ofertas y tarjetas de regalo de las mejores marcas.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. ¿Puedo usar mi cuenta actual de PokerBaazi?
                </div>
                <div className={style.sub_text3}>
                    ¡Sí! Puedes iniciar sesión con tu cuenta actual de PokerBaazi. Si eres nuevo, regístrate gratis en Google Play Store o Apple App Store — no se requiere depósito.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  ¿Se puede cambiar entre los modos de Juego Gratuito y Cash?
                </div>
                <div className={style.sub_text3}>
                    No. PokerBaazi ahora está completamente enfocado en el Juego Gratuito — una experiencia de práctica previa y basada en recompensas donde cada mano contribuye a tu progresión.
                </div>
            </div>
        </div>
    )
}


export function ESLeaderboardAndProgression() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Clasificaciones y Progresión" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  ¿Cómo funcionan las clasificaciones?
                </div>
                <div className={style.sub_text3}>
                    Las clasificaciones rastrean tu desempeño en juegos rápidos y torneos. Juega regularmente para ganar puntos, subir de rango y ganar Puntos de Recompensa bonus cada semana.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Mi rango en la clasificación no se actualiza.
                </div>
                <div className={style.sub_text3}>
                    Los rangos se actualizan cada pocos minutos. Si no ves la actualización, comparte tu nombre de usuario con nosotros en <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> y lo revisaremos para ti.
                </div>

            </div>
        </div>
    )
}

export function ESGameplayQueries() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Consultas de Juego" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  ¿Qué juegos puedo jugar?
                </div>
                <div className={style.sub_text3}>
                    Puedes jugar Texas Hold'em, Omaha, All-in or Fold, Super Hold'em y Open Face Poker (OFC) — disponibles en juegos rápidos y torneos.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Me quedé sin fichas. ¿Qué debo hacer?
                </div>
                <div className={style.sub_text3}>
                    Recibes fichas gratuitas diariamente, por hora y viendo anuncios. También puedes ganar más completando Recompensas de Tareas o clasificándote en las tablas de posiciones.
                </div>

            </div>
        </div>
    )
}

export function ESBaaziStore() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Baazi Store" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.   ¿Qué es la Baazi Store?
                </div>
                <div className={style.sub_text3}>
                    La Baazi Store es donde canjeas tus Puntos de Recompensa por cupones, ofertas y tarjetas de regalo de las mejores marcas — impulsado por Advantage Club.

                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.   Canjeé una recompensa pero no la recibí.
                </div>
                <div className={style.sub_text3}>
                    Los canjes pueden tardar hasta 48 horas en procesarse. Si aún no ha llegado, comparte el nombre de la recompensa elegida y la fecha de canje con nosotros en <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> y lo revisaremos de inmediato.

                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  ¿Necesito tener un inicio de sesión separado de Advantage Club?
                </div>
                <div className={style.sub_text3}>
                    No — inicias sesión automáticamente a través de PokerBaazi. No se requieren pasos adicionales. <br />
                    Para ofertas premium y drops sorpresa, explora la membresía Baazi Select.

                </div>


            </div>
        </div>
    )
}
export function ESBaaziSelectMembership() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Membresía Baazi Select" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q. ¿Qué es Baazi Select?
                </div>
                <div className={style.sub_text3}>
                    Baazi Select es nuestra <strong>suscripción de membresía premium</strong> que desbloquea funciones avanzadas de juego, personalizaciones visuales premium y acceso exclusivo a Poker TV — incluyendo temporadas próximas de <strong>The Circuit</strong>.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. ¿Qué incluye Baazi Select?
                </div>
                <div className={style.sub_text3}>
                    Baazi Select te da acceso a:
                    <ul className='m-0 ps-3 pt-2'>
                        <li>Avatares premium y temas de mesa</li>
                        <li>Herramientas de juego como Rabbit y Player Stats</li>
                        <li>Configuraciones de mesa mejoradas</li>
                        <li>Acceso completo a Poker TV</li>
                        <li>Ofertas exclusivas y expandidas en la Rewards Store</li>
                        <li>Acceso anticipado a próximas experiencias premium</li>
                    </ul>
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. ¿Baazi Select da ventaja en el juego?
                </div>
                <div className={style.sub_text3}>
                    No. Baazi Select está diseñado para <strong>mejorar tu experiencia y opciones de personalización</strong>. No crea ventajas injustas en el juego ni influye en los resultados.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. ¿Cómo obtengo Baazi Select?
                </div>
                <div className={style.sub_text3}>
                    Puedes suscribirte a Baazi Select desde:
                    <ul className='m-0 ps-3 pt-2'>
                        <li><strong>Sección de Membresía en la pantalla de inicio</strong></li>
                        <li><strong>Perfil → Membresía / Configuración</strong></li>
                    </ul>
                    La suscripción se factura de forma segura a través de <strong>Google Play Store / App Store</strong>.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. ¿Baazi Select es una suscripción con renovación automática?
                </div>
                <div className={style.sub_text3}>
                    Sí. Baazi Select se renueva automáticamente a través de tu <strong>cuenta de Google Play / App Store</strong> al final de cada ciclo de facturación, a menos que se cancele antes de la renovación.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. ¿Cómo cancelo mi membresía?
                </div>
                <div className={style.sub_text3}>
                    Puedes cancelar en cualquier momento desde la configuración de suscripción de tu dispositivo.<br />
                    <strong>Android:</strong> Google Play → Perfil → Pagos y suscripciones → Suscripciones → Baazi Select → Cancelar<br />
                    <strong>iPhone:</strong> Configuración → ID de Apple → Suscripciones → Baazi Select → Cancelar
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. ¿Qué pasa después de cancelar?
                </div>
                <div className={style.sub_text3}>
                    Los beneficios de tu membresía permanecerán activos hasta el <strong>final de tu período de facturación actual</strong>. Después de eso, la suscripción no se renovará y los beneficios premium expirarán.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. ¿Desinstalar la app cancela mi membresía?
                </div>
                <div className={style.sub_text3}>
                    No. Desinstalar la app no cancela tu suscripción. Para detener las renovaciones futuras, debes cancelar desde la <strong>configuración de suscripción de Google Play / App Store</strong>.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. ¿Cómo funciona Baazi Select con los Puntos de Recompensa?
                </div>
                <div className={style.sub_text3}>
                    Baazi Select desbloquea un <strong>conjunto premium de ofertas exclusivas y tarjetas de regalo de las mejores marcas</strong> en la Rewards Store. Sin membresía, solo está disponible una selección limitada de recompensas.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. ¿Puedo obtener un reembolso?
                </div>
                <div className={style.sub_text3}>
                    Los reembolsos por suscripciones compradas a través de <strong>Google Play Store / App Store</strong> deben solicitarse directamente en la tienda correspondiente. La aprobación del reembolso está sujeta a su política de facturación.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. ¿Qué más puedo esperar?
                </div>
                <div className={style.sub_text3}>
                    Baazi Select continuará evolucionando con:
                    <ul className='m-0 ps-3 pt-2'>
                        <li>Paquetes sorpresa en la Baazi Store</li>
                        <li>Nuevas herramientas premium y utilidades de juego</li>
                        <li>Nuevos temas y personalizaciones de mesa</li>
                        <li>Contenido exclusivo de Poker TV</li>
                        <li>Temporadas próximas de The Circuit</li>
                    </ul>
                </div>

            </div>
        </div>
    )
}

export function ESTaskRewards() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Recompensas de Tareas" />
            <div className="main-container mb-5 px-3"><div className={style.sub_text2_q}> Q. ¿Qué son las Recompensas de Tareas?  </div>
                <div className={style.sub_text3}>
                    <p>Las Recompensas de Tareas son desafíos diarios y semanales que te dan fichas o Puntos de Recompensa al completarlos. Te ayudan a progresar más rápido y mantenerte comprometido con nuevos objetivos cada día. </p>
                </div>
                <div className={style.brd}></div>
                <div className={style.sub_text2_q}>Q. No recibí mi recompensa de tarea.  </div>
                <div className={style.sub_text3}>
                    <p>Comparte el nombre de tu tarea y la hora de finalización con nosotros en <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> — nos aseguraremos de que se acredite lo antes posible. </p>
                </div>


            </div>
        </div>
    )
}

export function ESTechnicalQueries() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Consultas Técnicas" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q. La app no carga o muestra un error de red.
                </div>
                <div className={style.sub_text3}>
                    Intenta cerrar y volver a abrir la app y asegúrate de que tu conexión a internet sea estable. Si el problema persiste, envíanos una captura de pantalla y la versión de tu app a <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a>
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Me desconecté en medio de un juego.
                </div>
                <div className={style.sub_text3}>
                    Puedes volver a unirte a la misma mesa inmediatamente si el juego aún está activo. Tu progreso y puntos están seguros.                </div>

            </div>
        </div>
    )
}

export function ESWallet() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Cartera" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  ¿Qué son las Fichas?
                </div>
                <div className={style.sub_text3}>
                    Las Fichas son tu moneda en el juego que se usa para jugar partidas de póker y torneos. Puedes reclamarlas diariamente y por hora (cada 60 minutos) y también puedes obtenerlas viendo anuncios o completando tareas.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Me quedé sin Fichas. ¿Qué debo hacer?
                </div>
                <div className={style.sub_text3}>
                    Puedes reclamar fichas diariamente y por hora (cada 60 minutos). También puedes ganar más viendo anuncios o completando tareas de recompensa.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  ¿Qué son los Puntos de Recompensa?
                </div>
                <div className={style.sub_text3}>
                    Los Puntos de Recompensa se obtienen a través del juego — clasificándote en las tablas de posiciones, terminando en posiciones de pago en torneos o completando tareas. Puedes canjearlos en la Baazi Store por ofertas y tarjetas de regalo de las mejores marcas.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.   ¿Cómo gano Puntos de Recompensa?
                </div>
                <div className={style.sub_text3}>
                    Juega partidas, sube en las clasificaciones, completa tareas diarias o termina en posiciones de pago en torneos para ganar Puntos de Recompensa.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  ¿Cómo uso los Puntos de Recompensa?
                </div>
                <div className={style.sub_text3}>
                    Abre la Baazi Store en la app, elige tu oferta o cupón preferido y canjéalo usando tus Puntos de Recompensa disponibles.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.   ¿Se pueden canjear los Puntos de Recompensa por dinero?
                </div>
                <div className={style.sub_text3}>
                    No. Los Puntos de Recompensa solo se pueden usar para canjear ofertas o cupones en la Baazi Store.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Canjeé mis Puntos de Recompensa pero no recibí el artículo.
                </div>
                <div className={style.sub_text3}>
                    Por favor espera hasta 48 horas para el procesamiento. Si no lo recibes, comunícate con nosotros en <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> con el nombre de la recompensa elegida y la fecha de canje para obtener ayuda.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  ¿Puedo transferir Fichas o Puntos de Recompensa a otro jugador?
                </div>
                <div className={style.sub_text3}>
                    No. Tanto las Fichas como los Puntos de Recompensa no son transferibles y están vinculados únicamente a tu cuenta.                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  ¿Dónde puedo ver mis saldos?
                </div>
                <div className={style.sub_text3}>
                    Puedes ver tus Fichas y Puntos de Recompensa en la sección de Cartera de la app en cualquier momento.                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Mi saldo no se actualizó. ¿Qué debo hacer?
                </div>
                <div className={style.sub_text3}>
                    Actualiza la app o cierra sesión y vuelve a iniciar sesión. Si el problema persiste, comunícate con nosotros en <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> con tu nombre de usuario y los detalles del juego.               </div>
            </div>
        </div>
    )
}



